// The app's Text and TextInput: React Native's own, with the app's font added (src/fonts.ts).
// Screens import these instead of the ones from 'react-native' and change nothing else.
import React, { createContext, forwardRef, useContext } from 'react';
import { StyleSheet, Text as RNText, TextInput as RNTextInput } from 'react-native';
import type { TextInputProps, TextProps } from 'react-native';
import { fontFor, kindOf, type Kind } from '../fonts';

/** The family of the text we are inside of, so text nested in a mono label stays mono. */
const Parent = createContext<Kind | null>(null);

export const Text = forwardRef<RNText, TextProps>(function Text({ style, children, ...rest }, ref) {
  const parent = useContext(Parent);
  const flat = StyleSheet.flatten(style) || {};
  const font = fontFor(flat, parent);
  const asked = kindOf(flat.fontFamily);
  const here: Kind = asked === 'mono' ? 'mono' : asked === 'other' ? (parent ?? 'sans') : (parent ?? 'sans');
  return (
    <RNText ref={ref} {...rest} style={font ? [style, font] : style}>
      <Parent.Provider value={here}>{children}</Parent.Provider>
    </RNText>
  );
});
export type Text = RNText;

export const TextInput = forwardRef<RNTextInput, TextInputProps>(function TextInput({ style, ...rest }, ref) {
  const font = fontFor(StyleSheet.flatten(style) || {}, null);
  return <RNTextInput ref={ref} {...rest} style={font ? [style, font] : style} />;
});
export type TextInput = RNTextInput;
